import { getAptByPathAPI } from "@/apis/apt-api"
import { aptSearchStore } from "../select/apt/apt-search-store"
import { redirect } from "react-router-dom"

export const aptEnsureLoaded = async ({ region, aptCode }) => {
  const { pickApt } = aptSearchStore.getState()

  if (pickApt?.kapt_code === aptCode && pickApt?.sido === region) {
    return pickApt
  }

  const result = await getAptByPathAPI({ kapt_code: aptCode })

  if (!result) {
    throw redirect("/select")
  }

  if (result.sido_key?.toLowerCase() !== region.toLowerCase()) {
    throw redirect("/select")
  }

  aptSearchStore.getState().setPickApt({ ...result, sido: result.sido_key?.toLowerCase() })

  return result
}
